// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import type { UserData } from 'store/modules/user';
import type { State } from 'store';
import { BaseActions, SettingsActions } from 'store/actionCreators';

import SettingPassword from 'components/settings/SettingPassword';

type Props = {
  user: ?UserData,
};

class SettingPasswordContainer extends Component<Props> {
  lastRequestTime: ?number = null;
  initialize = async () => {
    const { user } = this.props;
  };

  componentDidMount() {
    this.initialize();
  }

  onChangePassword = async (password: string) => {
    await SettingsActions.changePassword(password);
    await this.initialize();
    BaseActions.showToast({ type: 'success', message: '비밀번호를 변경하였습니다.' });
  };

  render() {
    return <SettingPassword onChangePassword={this.onChangePassword} />;
  }
}

export default connect(
  ({ settings, user }: State) => ({
    user: user.user,
  }),
  () => ({}),
)(SettingPasswordContainer);



// WEBPACK FOOTER //
// ./src/containers/settings/SettingPasswordContainer.js